import { dataFormat2 } from "../../../functions/dataFormat";
import { handleFocus, handleBlur } from "../../../functions/utilities";

const WodaOdczytyRazemSzczegolyEdytujWmP = props => {

    const { edytowanyZakres, setEdytowanyZakres } = props;

    const handleK = e => setEdytowanyZakres( prevState => ({...prevState, okres_koniec: e.target.value}) );
    const handleWzk = e => setEdytowanyZakres( prevState => ({...prevState, zimna_stan_koniec: e.target.value}) );
    const handleWck = e => setEdytowanyZakres( prevState => ({...prevState, ciepla_stan_koniec: e.target.value}) );

    return (
        <div className="row">
            <div>
                <label htmlFor="k">
                    Koniec:
                </label>
                <input 
                    type="date"    
                    id="k"
                    value={dataFormat2(edytowanyZakres?.okres_koniec)}
                    onChange={handleK}
                />
            </div>
            <div>
                <label htmlFor="wzk">
                    Stan w. zimnej:
                </label>
                <input 
                    type="number" 
                    id="wzk" 
                    value={edytowanyZakres?.zimna_stan_koniec}
                    onChange={handleWzk}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                />
            </div>
            <div>
                <label htmlFor="wck">
                    Stan w. ciepłej:
                </label>
                <input 
                    type="number" 
                    id="wck" 
                    value={edytowanyZakres?.ciepla_stan_koniec}
                    onChange={handleWck}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                />
            </div>
        </div>
    )
}

export default WodaOdczytyRazemSzczegolyEdytujWmP;